import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthService } from '../services/auth.service';
import { filter, map, take } from 'rxjs/operators';
import { Observable, combineLatest } from 'rxjs';

export const validateAuthGuard: CanActivateFn = (route, state): Observable<boolean> => {
  const authService = inject(AuthService); // Inyecta el servicio de autenticación
  const router = inject(Router); // Inyecta el Router para redirecciones

  return combineLatest([authService.authChecked$, authService.isLogged$]).pipe(
    filter(([authChecked]) => authChecked),
    take(1),
    map(([, isLoggedIn]) => {
      // Si está autenticado y trata de acceder al login, redirige al home
      if (isLoggedIn && state.url.includes('/auth/login')) {
        router.navigate(['/admin/home']);
        return false;
      }

      // Si no está autenticado y trata de acceder a una ruta protegida, redirige al login
      if (!isLoggedIn && !state.url.includes('/auth')) {
        router.navigate(['/auth/login']);
        return false;
      }

      return true; // Permite el acceso si está autenticado
    })
  );
};
